import { render, staticRenderFns } from "./TweUntie.vue?vue&type=template&id=24ab2020&scoped=true&slot-scope=scope&"
import script from "./TweUntie.vue?vue&type=script&lang=js&"
export * from "./TweUntie.vue?vue&type=script&lang=js&"
import style0 from "./TweUntie.vue?vue&type=style&index=0&id=24ab2020&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab2020",
  null
  
)

export default component.exports